import * as _ from 'lodash';

export enum RowsPerPage {
  Compact = 5,
  Medium = 10,
  Large = 25,
  Huge = 50,
  Massive = 100,
}

export const defaultRowsPerPageOptions: number[] = [
  RowsPerPage.Compact,
  RowsPerPage.Medium,
  RowsPerPage.Large,
];

export const defaultIndexColumnWidth: number = 60;
export const defaultEditedItemStyleName: string = 'row-default-warning';

export class RecordCountConfigParams {
  showFilters?: boolean;
  enableFiltering: boolean;
  totalRecords: number;
}

export const defaultLoadEvent = {
  filters: {},
  first: 0,
  rows: RowsPerPage.Medium,
  sortOrder: 1,
};

export const onRowsReorder = <T>(
  rows: T[],
  rowNumberFieldName: keyof T,
  dragIndex: number,
  dropIndex: number,
  itemUpdateCallback: (row: T) => void
) : T[] => {
  const currentIndex = dragIndex > dropIndex ? dropIndex : dropIndex - 1;

  let leftBorder = dragIndex;
  let rightBorder = currentIndex;

  if (dragIndex > currentIndex) {
    leftBorder = currentIndex;
    rightBorder = dragIndex;
  }

  const affectedRowNumbers = rows
    .filter((row, i) => i >= leftBorder && i <= rightBorder)
    .map(row => row[rowNumberFieldName]);

  if (dragIndex < dropIndex) {
    affectedRowNumbers.unshift(affectedRowNumbers.pop());
  } else {
    affectedRowNumbers.push(affectedRowNumbers.shift());
  }

  let j = 0;
  return rows.map((row, i) => {
    if(i >= leftBorder && i <= rightBorder) {
      row[rowNumberFieldName] = affectedRowNumbers[j];
      itemUpdateCallback(row);
      j++;
      return _.cloneDeep(row);;
    }
    return row;
  });

}

